
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { isError } from "../../state/helpers/Error"
import { INTEGRATION_KEY } from "../../state/integration/Constants"

type RFPaymentStats = {
	balance:         string
	inTransitToBank: string
	lastPayout:      string
	currency:       string
}

class PaymentStatsHelper {

    static async getPaymentStats(merchantID: string, integrationKey: INTEGRATION_KEY): Promise<RFPaymentStats> {
        const res = await AppContext.getApiClient().get(`/${integrationKey}/merchants/${merchantID}/payments-stats`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as RFPaymentStats
    }

}

export default PaymentStatsHelper


// WEBPACK FOOTER //
// ./src/payment-account/service/paymentStatsHelper.ts